import { render, staticRenderFns } from "./CareLabelDialogue.vue?vue&type=template&id=72b74350&scoped=true&"
import script from "./CareLabelDialogue.vue?vue&type=script&lang=ts&"
export * from "./CareLabelDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./CareLabelDialogue.vue?vue&type=style&index=0&id=72b74350&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b74350",
  null
  
)

export default component.exports